import {
  Box,
  Button,
  Chip,
  Grid,
  Skeleton,
  Typography
} from "@mui/material";
import config from '../../../Config/config.json'
import React from "react";

interface ProductListProps {
  loading: boolean;
  filteredProducts: any[];
  orderItems: any[];
  openDrawer: (product: any) => void;
}

export const ProductListUI: React.FC<ProductListProps> = ({
  loading,
  filteredProducts,
  orderItems,
  openDrawer
}) => {
  return (
    <Box
      sx={{
        maxHeight: "30rem",
        overflowY: "auto",
        overflowX: "hidden",
        paddingRight: 1,
        position: "relative"
      }}
    >
      {loading ? (
        <Box
          sx={{
            border: "1px solid #ddd",
            borderRadius: 2,
            p: 2,
            mb: 2,
            backgroundColor: "white",
            display: "flex",
            alignItems: "center"
          }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={8}>
              <Skeleton variant="text" width="60%" height={28} />
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                <Skeleton variant="rounded" width={80} height={24} />
              </Box>
              <Box sx={{ mt: 1 }}>
                {[...Array(5)].map((_, index) => (
                  <Skeleton
                    key={index}
                    variant="text"
                    width="80%"
                    height={20}
                  />
                ))}
              </Box>
            </Grid>
            <Grid
              item
              xs={4}
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
            >
              <Skeleton variant="rounded" width={60} height={60} />
              <Skeleton
                variant="rounded"
                width={80}
                height={32}
                sx={{ mt: 1 }}
              />
            </Grid>
          </Grid>
        </Box>
      ) : filteredProducts ? (
        filteredProducts.map((product) => {
          const isSelected = orderItems.some(
            (item) =>
              item.productId === product.productId &&
              product.types.some((type: any) =>
                type.services.some(
                  (service: any) => service.serviceId === item.serviceId
                )
              )
          );

          return (
            <Box
              key={product.id}
              sx={{
                border: "1px solid #ddd",
                borderRadius: 2,
                p: 2,
                mb: 2,
                backgroundColor: "white",
                display: "flex",
                alignItems: "center"
              }}
            >
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={8}>
                  <Typography variant="h6" fontWeight="bold">
                    {product.productName}
                  </Typography>
                  {product.types.length > 0 && (
                    <Box
                      sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}
                    >
                      {product.types.map((type: any) => (
                        <Chip
                          key={type.productType}
                          label={type.productType}
                          size="small"
                          sx={{ backgroundColor: "#e0e0e0" }}
                        />
                      ))}
                    </Box>
                  )}

                  {/* Show only the first available service */}
                  {product.types.length > 0 &&
                    product.types[0].services.length > 0 && (
                      <Box sx={{ mt: 1 }}>
                        <Typography variant="body2" sx={{ color: "#444" }}>
                          {product.types[0].services[0].serviceName} - ₹
                          {product.types[0].services[0].price}/pc
                        </Typography>
                      </Box>
                    )}
                </Grid>

                <Grid
                  item
                  xs={4}
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                >
                  {product.imageUrl && (
                    <img
                      src={`${config.imgUrl}/${product.imageUrl}`}
                      alt={product.productName}
                      style={{
                        width: 60,
                        height: 60,
                        objectFit: "cover",
                        borderRadius: 8,
                        marginBottom: 8
                      }}
                    />
                  )}
                  <Button
                    variant={isSelected ? "outlined" : "contained"}
                    size="small"
                    onClick={() => openDrawer(product)}
                    sx={{ fontSize: "0.700rem",backgroundColor: "#7D79C2", }}
                  >
                    {isSelected ? "Added" : "Add"}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          );
        })
      ) : (
        <Typography>No Products to Show</Typography>
      )}
    </Box>
  );
};
